import { motion } from '@eversports/react-components/design-tokens/motion'
import { parseApolloError } from '@eversports/react-components/logical/parse-apollo-error'
import { SimpleFlex } from '@eversports/react-components/primitives/Flex'
import Logo from '@eversports/react-components/primitives/Logo'
import { makeStyles } from '@mui/styles'
import { parse } from 'query-string'

import { useLocation } from 'react-router-dom'
import CorporatePartnerLogo from '../components/CorporatePartnerLogo'
import VenueLogo from '../components/VenueLogo'
import useCompany from '../data/use-company'
import useCorporateInvitation from '../data/use-corporate-invitation'
import useVenue from '../data/use-venue'
import { Origin } from '../graphql'
import { getAuthParams } from '../utils/get-auth-params'

const useStyles = makeStyles({
  wrapper: {
    height: 144,
    width: 144,
    marginBottom: 24,
    marginTop: 24,
    textAlign: 'center',
    '& *': {
      maxHeight: '100%',
    },
  },
})

const PageLogoWrapperContent = () => {
  const {
    data: corporatePartnerData,
    error: corporatePartnerError,
    active: hasCorporatePartner,
  } = useCorporateInvitation()
  const location = useLocation()
  const { redirectApp } = parse(location.search)
  const params = getAuthParams(location.search)
  const { data: venueData, error: venueError } = useVenue()
  const { data: companyData, error: companyError } = useCompany()
  const hasWidgetOrigin = params.origin === Origin.ORIGIN_WIDGET || redirectApp === 'widget'

  if (hasWidgetOrigin) {
    const venue = venueData?.venue
    const company = venue?.company || companyData?.company
    const widgetBrandSettings = company?.widgetBrandSettings
    const brandingName = widgetBrandSettings?.displayName ?? company?.name ?? null
    const brandingLogo = widgetBrandSettings?.logo?.large ?? null

    return (
      <VenueLogo
        brandingName={brandingName}
        logoUrl={brandingLogo}
        error={parseApolloError(venueError || companyError)}
      />
    )
  }

  if (hasCorporatePartner) {
    return (
      <CorporatePartnerLogo
        logo={corporatePartnerData?.corporateInvitation?.corporatePartner.logo}
        error={parseApolloError(corporatePartnerError)}
      />
    )
  }

  return <Logo type="horizontal" height="32px" />
}

const PageLogoWrapper = () => {
  const classes = useStyles()

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <SimpleFlex flexDirection="column" alignItems="center" justifyContent="center" className={classes.wrapper}>
        <PageLogoWrapperContent />
      </SimpleFlex>
    </motion.div>
  )
}

export default PageLogoWrapper
